var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KemudahanAsasBase',{attrs:{"amenity":_vm.amenity}})
}
var staticRenderFns = []

export { render, staticRenderFns }